// extracted by mini-css-extract-plugin
export default {"userName":"index_userName_Ug4SZ clearfix","label":"index_label_YLPxB","input":"index_input_sfc-w","loginregi":"index_loginregi_0rQ67","error":"index_error_KtueL"};